// --------------------------------------------------------
// ---------------   TRD  SERIES        -------------------
// --------------------------------------------------------

import {
  setSuccessMsg,
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiCloseModalEdit,
  uiOpenErrorAlert,
  uiOpenSuccessAlert,
} from "../../../../redux/actions/uiActions";
import { AppState } from "../../../../redux/reducers/rootReducer";
import { ITrdAction, ITrdSeries, Types } from "../../../../redux/types/types";
import {
  AuditAction,
  setAuditAction,
} from "../../../audit/actions/auditAction";
import { deleteSerieAudit } from "../../../audit/firebase/AuditServices";
import {
  deleteTrdSerie,
  getTrdSeries,
  loadSeriesById,
  setTrdSerie,
  setTrdVersion,
} from "../../firebase/serieService";
import { IValidateProductionOffice } from "../../form/IValidateProductionOffice";

import { addOrEditTrdVersion } from "./trdActions";

export const deleteSerie = (idSerie: string): ITrdAction => ({
  type: Types.deleteSerie,
  payload: idSerie,
});

export const setActiveSerie = (serie: ITrdSeries | null): ITrdAction => ({
  type: Types.setActiveSerie,
  payload: serie,
});

export const setSerie = (serie: ITrdSeries): ITrdAction => ({
  type: Types.setTrdSerie,
  payload: serie,
});

const loadSeries = (series: ITrdSeries[]): ITrdAction => ({
  type: Types.loadSeries,
  payload: series,
});

export const startDeleteSerie = (idSerie: string) => {
  return async (dispatch: any, getState: any) => {
    const { user } = (getState() as AppState).auth;
    const { versions, activeSerie } = (getState() as AppState).trd;

    if (!user || !user.idEntity || !activeSerie) {
      throw new Error("falta de información del usuario o una serie activa");
    }

    const versionIndex = versions.findIndex(
      (ver) => ver.idVersion === activeSerie.idVersion
    );

    if (versionIndex !== -1) {
      const versionState = { ...versions[versionIndex] };
      let versionSeries = versionState.series;
      if (versionSeries) {
        versionSeries = versionSeries.filter(
          (version) => version !== activeSerie.idSerie
        );
        versionState.series = [...versionSeries];

        auditSerieId(idSerie, user);

        const { ok } = await deleteTrdSerie(user.idEntity, idSerie);
        const { ok: okVersion } = await setTrdVersion(
          user.idEntity,
          versionState
        );

        if (ok && okVersion) {
          dispatch(deleteSerie(idSerie));
          dispatch(addOrEditTrdVersion(versionState));
          dispatch(uiCloseModalDelete());
          dispatch(setSuccessMsg("SerieDeleted"));
          dispatch(uiOpenSuccessAlert());
        } else {
          dispatch(uiOpenErrorAlert());
        }
      }
    }
  };
};

const auditSerieId = async (idSerie: string, user: any) => {
  const serieById: IValidateProductionOffice = {
    idProductionOffice: idSerie,
    idEntity: user.idEntity,
  };

  let getserieById = await loadSeriesById(serieById);
  const auditLog = setAuditAction(user, AuditAction.DELETE);

  return await deleteSerieAudit(getserieById, auditLog);
};

export const startLoadSeries = (idEntiy: string) => {
  return async (dispatch: any) => {
    const series = await getTrdSeries(idEntiy);
    if (series.length > 0) {
      dispatch(loadSeries(series));
    }
  };
};

export const startSetSerie = (serie: ITrdSeries, edit: boolean) => {
  return async (dispatch: any, getState: any) => {
    const { user } = (getState() as AppState).auth;
    const { versions, activeSerie } = (getState() as AppState).trd;
    if (!user || !user.idEntity) {
      throw new Error("falta de información del usuario ");
    }
    const idSerie = !activeSerie
      ? `${serie.serieCode}_${Date.now()}`
      : activeSerie.idSerie;
    const objSerie: ITrdSeries = {
      ...serie,
      idSerie,
    };
    const versionIndex = versions.findIndex(
      (ver) => ver.idVersion === serie.idVersion
    );
    if (versionIndex >= 0) {
      const versionState = versions[versionIndex];
      let seriesToTrd = versionState.series
        ? [idSerie, ...(versionState.series as string[])]
        : [idSerie];

      const { ok } = await setTrdSerie(
        user.idEntity,
        objSerie,
        // @ts-ignore
        activeSerie ? [...seriesToTrd] : seriesToTrd
      );

      if (ok) {
        // @ts-ignore
        versionState.series = activeSerie ? [...seriesToTrd] : seriesToTrd;
        dispatch(addOrEditTrdVersion(versionState));
        dispatch(setSerie(objSerie));
        dispatch(setSuccessMsg(!edit ? "SerieCreated" : "SerieUpdated"));
        dispatch(uiCloseModalAdd());
        dispatch(uiCloseModalEdit());
        dispatch(setActiveSerie(null));
        dispatch(uiOpenSuccessAlert());
      }
    }
  };
};
